import { CurrencyCode } from '@liveauctioneers/hammer-ui-liveauctioneers/lotDetail';
import { useState } from 'react';

import useIsWiderThan from '@/hooks/useIsWiderThan';
import { useAppSelector } from '@/redux/hooks';
import { getLiveCatalogCurrentItemId } from '@/redux/modules/console';

import { BiddingConsoleLeftSection } from './components/BiddingConsoleLeftSection/BiddingConsoleLeftSection';
import { BiddingConsoleMiddleSection } from './components/BiddingConsoleMiddleSection/BiddingConsoleMiddleSection';
import { BiddingConsoleRightSection } from './components/BiddingConsoleRightSection/BiddingConsoleRightSection';

type Props = {
    catalogId: number;
};

// Tailwind's consoleThreeColumn breakpoint is min-width: 1400px.
// useIsWiderThan uses strict >, so 1399 = width >= 1400.
const THREE_COLUMN_BREAKPOINT = 1399;

export const DesktopBiddingConsoleExperiment = ({ catalogId }: Props) => {
    const itemId = useAppSelector((state) => getLiveCatalogCurrentItemId(state, catalogId));
    const isThreeColumn = useIsWiderThan(THREE_COLUMN_BREAKPOINT);
    const [selectedCurrency, setSelectedCurrency] = useState<CurrencyCode>();

    return (
        <div className="h-screen w-full bg-background-subdued">
            <div className="mx-auto grid grid-cols-[minmax(250px,402px)_minmax(400px,1fr)] gap-md p-md consoleThreeColumn:grid-cols-[minmax(250px,402px)_minmax(400px,1fr)_minmax(250px,402px)] consoleThreeColumn:[&>*:nth-child(3)]:grid">
                <BiddingConsoleLeftSection
                    catalogId={catalogId}
                    selectedCurrency={selectedCurrency}
                    setSelectedCurrency={setSelectedCurrency}
                />
                <BiddingConsoleMiddleSection
                    catalogId={catalogId}
                    itemId={itemId}
                    selectedCurrency={selectedCurrency}
                    isThreeColumn={isThreeColumn}
                />
                <BiddingConsoleRightSection
                    catalogId={catalogId}
                    isThreeColumn={isThreeColumn}
                />
            </div>
        </div>
    );
};
